import { createStitches } from '@stitches/react';

export const { styled, keyframes, css, theme } = createStitches({
  theme: {
    colors: {
      primaryDefault: '#00D651',
      neutralVeryDark: '#000000',
      neutralVeryLight: '#FFFFFF',
    },
  },
  media: {
    deviceLarge: '(min-width: 1024px)',
  },
});